import {WidgetLinkingGroupId} from '../../enums/widget-linking-group';
import {createCustomSplitLayoutDef} from '../../pages/backoffice/backoffice-default-layout.definition';
import {CHART_WIDGET_TYPE_ID} from '../../widgets/chart-widget/chart-widget-type-id';
import {DEX_DEV_RATES_WIDGET_TYPE_ID} from '../../widgets/dex-dev-rates-widget/dex-dev-rates-widget-type-id';
import {DEX_LP_COLLAPSED_WIDGET_TYPE_ID} from '../../widgets/dex-lp-collapsed-widget/dex-lp-collapsed-widget-type-id';
import {
    DEX_TRANCHE_DETAILS_WIDGET_TYPE_ID
} from '../../widgets/dex-tranche-details-widget/dex-tranche-details-widget-type-id';
import {DEX_TX_HISTORY_WIDGET_TYPE_ID} from '../../widgets/dex-tx-history-widget/dex-tx-history-widget-type-id';
import {DEX_WALLET_WIDGET_TYPE_ID} from '../../widgets/dex-wallet-widget/dex-wallet-widget-type-id';
import {Dimension} from '../layout/abstract-units';
import {TabDefinition} from './tab-definition';

export const DEFAULT_TAB_DEFINITIONS = (): TabDefinition[] => {
    const L_PRODUCTS = createCustomSplitLayoutDef(
        [
            {
                widgetTypeId: DEX_LP_COLLAPSED_WIDGET_TYPE_ID,
                linkingGroupId: WidgetLinkingGroupId.BLUE
            },
            {
                widgetTypeId: DEX_TRANCHE_DETAILS_WIDGET_TYPE_ID,
                linkingGroupId: WidgetLinkingGroupId.BLUE
            },
            [DEX_WALLET_WIDGET_TYPE_ID, DEX_DEV_RATES_WIDGET_TYPE_ID],
            [
                DEX_TX_HISTORY_WIDGET_TYPE_ID,
                {
                    widgetTypeId:   CHART_WIDGET_TYPE_ID,
                    linkingGroupId: WidgetLinkingGroupId.BLUE
                }
            ]
        ],
        ({cellIds: [lp, tr, w, tx], WIDTH, HEIGHT, HALF_WIDTH, HALF_HEIGHT}) => [
            {
                axis:          Dimension.Y,
                movingAxisPos: HALF_WIDTH,
                axisRange:     [0, HALF_HEIGHT * 1.1],
                sides:         [[tr], [lp]]
            },
            {
                axis:          Dimension.Y,
                movingAxisPos: WIDTH * 0.28,
                axisRange:     [HALF_HEIGHT * 1.1, HEIGHT],
                sides:         [[tx], [w]]
            },
            {
                axis:          Dimension.X,
                movingAxisPos: HALF_HEIGHT * 1.1,
                axisRange:     [0, WIDTH],
                sides:         [[w, tx], [lp, tr]]
            }
        ]
    );

    return [
        {
            id: null,
            name: 'Liquidity Products',
            layout: L_PRODUCTS,
            floatLayout: null
        }
    ];
};
